/**
 * ProfileUnavailable — error fallback for PortErrorBoundary when memberProfile port is absent or throws.
 *
 * Rendered when the memberProfile port slot is not configured or when useMemberProfile() throws.
 * Provides a user-facing error message without crashing the shell navigation.
 *
 * Matches existing PortErrorBoundary props interface (used for ContentUnavailable pattern).
 *
 * Owned by feature 018-omat-tiedot.
 * Task: T016
 */

import type { JSX } from 'react';
import { useTranslate } from '../../i18n/useTranslate.js';

export function ProfileUnavailable(): JSX.Element {
  const t = useTranslate();

  return (
    <div className="flex flex-col items-center justify-center gap-4 px-4 py-12 text-center">
      <h2 className="text-lg font-semibold text-foreground">{t('profile.title')}</h2>
      <p className="text-sm text-muted-foreground">{t('profile.unavailable')}</p>
    </div>
  );
}
